// Filename: routes/AppRouter.js
// import Backbone from 'backbone';

var AppRouter = Backbone.Router.extend({
    routes: {
        // Default route
        '*actions': 'default'
    }
});

var initialize = function() {
    var appRouter = new AppRouter;
};

export default {
    initialize : initialize
};
